import { storeId } from '@/stores/storeId'
import { defineStore } from 'pinia'

import { fetchDeployVersionManifest } from '@/lib/deployVersion'
import { appErrorService } from '@/services/AppErrorService'

interface DeployVersionStoreState {
  bootBuildHash: string | null
  bootVersion: string | null
  bootCommit: string | null
  latestBuildHash: string | null
  deployStale: boolean
  lastCheckedAt: number | null
}

export const useDeployVersionStore = defineStore(storeId.DEPLOY_VERSION, {
  state: (): DeployVersionStoreState => ({
    bootBuildHash: null,
    bootVersion: null,
    bootCommit: null,
    latestBuildHash: null,
    deployStale: false,
    lastCheckedAt: null
  }),
  actions: {
    async captureBootVersion(): Promise<void> {
      if (import.meta.env.DEV) return
      const manifest = await fetchDeployVersionManifest()
      this.lastCheckedAt = Date.now()
      if (!manifest) {
        appErrorService.reportError(new Error('captureBootVersion: failed to load /version.json'))
        return
      }
      this.bootBuildHash = manifest.buildHash
      this.bootVersion = manifest.version
      this.bootCommit = manifest.commit
      this.latestBuildHash = manifest.buildHash
    },
    async pollDeployVersion(): Promise<void> {
      if (import.meta.env.DEV) return
      if (!this.bootBuildHash) return
      if (this.deployStale) return
      const manifest = await fetchDeployVersionManifest()
      this.lastCheckedAt = Date.now()
      if (!manifest) return
      this.latestBuildHash = manifest.buildHash
      if (manifest.buildHash !== this.bootBuildHash) {
        this.deployStale = true
      }
    }
  }
})
